
import React, { useState } from "react";
import AuraBadge from "@/components/common/AuraBadge";
import { useNavigate } from "react-router-dom";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { FollowersList } from "./FollowersList";

interface ProfileStatsProps {
  followersCount: number;
  followingCount: number;
  totalLikes: number;
  eloRating?: number;
  profileId: string;
}

const ProfileStats = ({ 
  followersCount = 0, 
  followingCount = 0, 
  totalLikes = 0, 
  eloRating = 0,
  profileId
}: ProfileStatsProps) => {
  const [isNetworkOpen, setIsNetworkOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("followers");
  
  const handleFollowersClick = () => {
    setActiveTab("followers");
    setIsNetworkOpen(true);
  };

  const handleFollowingClick = () => {
    setActiveTab("following");
    setIsNetworkOpen(true);
  };

  return (
    <>
      <div className="grid grid-cols-2 gap-4">
        <div 
          className="cursor-pointer hover:opacity-80 transition-opacity" 
          onClick={handleFollowersClick}
        >
          <div className="text-xl font-bold">{followersCount || 0}</div>
          <div className="text-xs text-gray-400">FOLLOWERS</div>
        </div>
        <div 
          className="cursor-pointer hover:opacity-80 transition-opacity"
          onClick={handleFollowingClick}
        >
          <div className="text-xl font-bold">{followingCount || 0}</div>
          <div className="text-xs text-gray-400">FOLLOWING</div>
        </div>
        <div className="flex flex-col items-start gap-1">
          <AuraBadge value={eloRating} size="sm" />
          <div className="text-[10px] text-gray-400 uppercase tracking-wide">Aura</div>
        </div>
        <div>
          <div className="text-xl font-bold">{totalLikes}</div>
          <div className="text-xs text-gray-400">LIKES</div>
        </div>
      </div>

      <Dialog open={isNetworkOpen} onOpenChange={setIsNetworkOpen}>
        <DialogContent className="sm:max-w-md bg-[#1A1F2C] border-gray-800 text-white">
          <DialogHeader>
            <DialogTitle className="text-center mb-4">Network</DialogTitle>
          </DialogHeader>
          
          <Tabs defaultValue={activeTab} value={activeTab} onValueChange={setActiveTab} className="w-full">
            <TabsList className="grid grid-cols-2 mb-4">
              <TabsTrigger value="followers">Followers ({followersCount})</TabsTrigger>
              <TabsTrigger value="following">Following ({followingCount})</TabsTrigger>
            </TabsList>
            
            <TabsContent value="followers" className="mt-0">
              <FollowersList profileId={profileId} type="followers" />
            </TabsContent>
            
            <TabsContent value="following" className="mt-0">
              <FollowersList profileId={profileId} type="following" />
            </TabsContent>
          </Tabs>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ProfileStats;
